import React from 'react';

import FinancingRedirect from 'Modules/patientfi/routes/FinancingRedirect';
import FinancingSuccess from 'Modules/patientfi/routes/FinancingSuccess';

import FinancingDeclined from 'Modules/patientfi/routes/FinancingDeclined';
import Financing from 'Modules/patientfi/routes/Financing';
import CreateApplication from './routes/CreateApplication';
import FinancingRequalify from 'Modules/patientfi/routes/FinancingRequalify';

import { Payment } from 'Modules/cardPayment/routes/Payment';
import MixedSuccess from 'Modules/patientfi/routes/MixedSuccess';
import MixedError from 'Modules/patientfi/routes/MixedError';

export const createFinancingPath = '/financing-patientfi/financing';
export const financingPath = '/financing-patientfi/office/finance';
export const financingSuccessPath = '/financing-patientfi/funded';
export const financingErrorPath = '/financing-patientfi/declined';
export const paymentOptionsPath = '/card-payment/cards';
export const createSecondaryFinancingPath = '/financing-patientfi/financing/secondary';
export const financingRequalifyPath = '/financing-patientfi/requalify';

export const mixedAvailableCreditPath = '/financing-patientfi/mixed/available-credit';
export const mixedDownPaymentCheckoutPath = '/financing-patientfi/mixed/down-payment/checkout';
export const mixedFinancingPath = '/financing-patientfi/mixed/financing';
export const mixedSuccessPath = '/financing-patientfi/mixed/success';
export const mixedErrorPath = '/financing-patientfi/mixed/error';

export const routes = [
  { path: createFinancingPath, element: <FinancingRedirect /> },
  { path: createSecondaryFinancingPath, element: <CreateApplication type="secondary" /> },
  {
    path: financingPath,
    element: (
      <Financing nextRoutes={{ success: financingSuccessPath, error: financingErrorPath }} />
    ),
  },
  {
    path: financingSuccessPath,
    element: <FinancingSuccess />,
  },
  {
    path: financingErrorPath,
    element: <FinancingDeclined />,
  },
  {
    path: financingRequalifyPath,
    element: <FinancingRequalify />,
  },

  {
    path: mixedDownPaymentCheckoutPath,
    element: (
      <Payment
        paymentType="downPayment"
        nextRoutes={{
          success: mixedFinancingPath,
          error: mixedErrorPath,
        }}
      />
    ),
  },
  {
    path: mixedFinancingPath,
    element: <Financing nextRoutes={{ success: mixedSuccessPath, error: mixedErrorPath }} />,
  },
  {
    path: mixedSuccessPath,
    element: <MixedSuccess />,
  },
  {
    path: mixedErrorPath,
    element: <MixedError />,
  },
];
